import React from "react";
import Image from "../base/image";
import Button from "../base/button";
import { kebabCase } from "../../utilities/helper";
import { useCollectAnchorLinks } from "../../context/anchorLinksContextProvider";
import Breadcrumb from "../breadcrumb";

const BodyBanner = (bannerClass, bannerData, blockIndex, forceH1 = false, breadcrumbSettings) => {
  const {
    id,
    title,
    bodyCopy,
    buttonText,
    buttonLink,
    buttonType,
    backgroundColor,
    fullBleedImage,
    bannerImage,
    imagePosition,
    bannerDivider,
    objectFit,
  } = bannerData;
  // const heading = title ? <h2 className="h1">{title}</h2> : "";
  const heading = title ? (
    forceH1 ? <><Breadcrumb settings={breadcrumbSettings} /><h1 className="xl-heading">{title}</h1></> : <h2 className="xl-heading">{title}</h2>
  ) : "";
  const Anchor = bannerData?.anchor ?? kebabCase(title) ?? id;
  useCollectAnchorLinks(title, bannerData?.anchor, blockIndex);

  const copy = bodyCopy ? <p className="h4">{bodyCopy}</p> : "";
  const button =
    buttonText && buttonLink ? (
      <Button
        href={buttonLink}
        type={`btn-${buttonType ? buttonType : backgroundColor === "starlight-purple" ? "tertiary-reverse" : "primary"}`}
        text={buttonText}
      />
    ) : (
      ""
    );
  const bannerImg = bannerImage ? (
    <Image imageData={bannerImage} alt={bannerImage.title} objectFit={objectFit ? "contain" : "cover"} fluid={bannerImage.fluid} />
  ) : (
    ""
  );

  const landscapeOrPortrait =
    !bannerImage?.gatsbyImageData?.width ||
    !bannerImage?.gatsbyImageData?.height ||
    bannerImage?.gatsbyImageData.width === bannerImage?.gatsbyImageData.height
      ? "square"
      : bannerImage?.gatsbyImageData.width > bannerImage?.gatsbyImageData?.height
      ? "landscape"
      : "portrait";

  return (
    <div className={`banner bg-${backgroundColor} ${bannerClass}${bannerDivider ? " divider" : ""}`} id={Anchor}>
      <div className={`banner--wrapper ${imagePosition}`}>
        {bannerImage ? <div className={`banner--wrapper__image ${fullBleedImage ? "" : "space"} ${landscapeOrPortrait}`}>{bannerImg}</div> : null}

        <div className={`banner--wrapper__content`}>
          {heading}
          {copy}
          {button}
        </div>
      </div>
    </div>
  );
};

export default BodyBanner;
